import { ENUM_LABELS, toOptions } from '#shared/types';

/**
 * Mapping between a numeric id held in form state and the string a `<select>`
 * shows, shared by the forms that pick a record by id.
 *
 * `0` and `null` both mean "nothing chosen yet": required ids start at 0 so the
 * schema rejects them, optional ones start at null so they are sent as such.
 */
export function idChoice(id: number | null | undefined): string {
  return id === 0 || id == null ? '' : String(id);
}

export interface Named {
  id: number;
  name: string;
}

interface NamedWithCode extends Named {
  code: string;
}

/** Options labelled by name alone: departments, suppliers. */
export function nameOptions(rows: readonly Named[]) {
  return rows.map((row) => ({ value: String(row.id), label: row.name }));
}

/** Options labelled "Name (CODE)", for catalogues where names repeat. */
export function nameAndCodeOptions(rows: readonly NamedWithCode[]) {
  return rows.map((row) => ({ value: String(row.id), label: `${row.name} (${row.code})` }));
}

/** Choices every form that records a person or a payment offers. */
export const GENDER_OPTIONS = toOptions(ENUM_LABELS.gender);
export const MARITAL_STATUS_OPTIONS = toOptions(ENUM_LABELS.maritalStatus);
export const PAYMENT_METHOD_OPTIONS = toOptions(ENUM_LABELS.paymentMethod);
